import React from 'react';
import ReactDOM from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  title?: React.ReactNode;
  children: React.ReactNode;
  width?: string;
  className?: string;
  headerLeft?: React.ReactNode;
  headerExtra?: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ open, onClose, title, children, width, className, headerLeft, headerExtra }) => {
  return ReactDOM.createPortal(
    <AnimatePresence>
      {open && (
        <motion.div
          className="modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className={`modal-content${className ? ` ${className}` : ''}`}
            style={{ maxWidth: width || '480px' }}
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            transition={{ duration: 0.2 }}
            onClick={(e) => e.stopPropagation()}
          >
            {title || headerLeft || headerExtra ? (
              <div className="modal-header" style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid #e2e8f0' }}>
                {headerLeft && (
                  <div style={{ position: 'absolute', left: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    {headerLeft}
                  </div>
                )}
                <h3 style={{ margin: 0, textAlign: 'center', flex: 1, fontSize: '16px' }}>{title}</h3>
                <div style={{ position: 'absolute', right: '16px', display: "flex", alignItems: "center", gap: "10px" }}>
                  {headerExtra}
                  <button className="modal-close" onClick={onClose} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent', border: 'none', cursor: 'pointer', color: '#64748b' }}>
                    <X size={20} />
                  </button>
                </div>
              </div>
            ) : null}
            <div className="modal-body">{children}</div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body
  );
};

export default Modal;
